/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentEventSeverities } from './equipment-event-severities';
import { SortExpression } from './sort-expression';
import { DateTimePeriod } from './date-time-period';


export interface SearchEquipmentEventHistoryRequest { 
    skip?: number;
    take?: number;
    includeTotalCount?: boolean | null;
    sortExpressions?: Array<SortExpression> | null;
    keyword?: string | null;
    workerIds?: Array<string> | null;
    equipmentIds?: Array<string> | null;
    categoryIds?: Array<number> | null;
    datePeriod?: DateTimePeriod;
    stateSeverities?: Array<EquipmentEventSeverities> | null;
}

